module.exports = __webpack_public_path__ + "img/step4-mobile-fr.13754d99.webp";